import request from '@/utils/request'

let Hproduct_formulaApi = {

  /*产品公式列表*/
  list(data) {
    return request._post('/shop/plus.hproduct_formula.Index/index', data);
},
/*添加产品公式*/
add(data) {
    return request._post('/shop/plus.hproduct_formula.Index/add', data);
},
/*修改产品公式*/
edit(data) {
    return request._post('/shop/plus.hproduct_formula.Index/edit', data);
},
/*删除产品公式*/
del(data) {
    return request._post('/shop/plus.hproduct_formula.Index/del', data);
},
/*产品公式详情*/
detail(data) {
  return request._post('/shop/plus.hproduct_formula.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.hproduct_formula.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.hproduct_formula.Setting/getSetting', data, errorback);
    },
}
export default Hproduct_formulaApi;



// WEBPACK FOOTER //
// ./src/api/hproduct_formula.js